/**
 * Sunday page sections (sections/sunday-c-*.liquid): the small bits of behaviour they share.
 * - Specs: "All specs" opens the rest on a phone; "Weight to carry" follows the width chosen in the buy hero.
 * - What owners say: "More reviews" on a phone; "Write a review" / "Ask a question" open Judge.me's own
 *   forms. Judge.me's widget waits in a <template>; the first tap adds it (hidden), loads its files the way
 *   Judge.me's own loader does (its core, then the widget), and clicks its button once it appears.
 *   If that doesn't happen within 8 s, the tap goes to the all-reviews page. Nothing is sent from here.
 * - Questions: "All N questions".
 * Loaded once per page however many sections use it.
 */
if (!window.__sdC) {
  window.__sdC = true;
  const fill = (s, v) => String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in v ? v[k] : m));

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-csp-all], [data-crv-more], [data-cfq-all], [data-crv-write], [data-crv-ask]');
    if (!t) return;
    if (t.matches('[data-csp-all]')) {
      t.closest('.sd-csp').classList.add('sd-open');
      t.remove();
    } else if (t.matches('[data-crv-more]')) {
      t.closest('.sd-crv').querySelector('[data-crv-list]').classList.add('sd-open');
      t.remove();
    } else if (t.matches('[data-cfq-all]')) {
      const l = t.closest('.sd-cfq').querySelector('[data-cfq]');
      l.classList.add('sd-open');
      const first = l.querySelector('.sd-cfq-x summary');
      t.remove();
      if (first) first.focus({ preventScroll: true });
    } else {
      openJm(t);
    }
  });

  // Judge.me on demand: add the widget from its template, load its files once, then press its own button.
  const allReviews = () => { location.href = (document.querySelector('.sd-crv-all a') || {}).href || location.href; };
  const addJm = (jm) => {
    const tpl = jm.querySelector('template[data-crv-jm-tpl]');
    if (!tpl) return;
    jm.append(document.importNode(tpl.content, true));
    tpl.remove();
    // inline data scripts don't run from a template: run them now
    jm.querySelectorAll('script:not([src])').forEach((o) => {
      const n = document.createElement('script');
      n.textContent = o.textContent;
      o.replaceWith(n);
    });
    const j = window.jdgm;
    const w = jm.querySelector('.jdgm-widget[data-entry-point]');
    const base = j && j.CDN_BASE_URL;
    if (!w || !base || !j.loadScript) return;
    const src = base + w.dataset.entryPoint;
    if (document.querySelector(`script[src="${src}"]`)) return;
    const css = (href) => {
      if (document.querySelector(`link[href="${href}"]`)) return;
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      document.head.append(l);
    };
    // the widget itself: its CSS from the manifest, then its module
    const widget = () =>
      fetch(`${base}manifest.json?v=${Date.now()}`)
        .then((r) => r.json())
        .then((m) => {
          const walk = (k) => {
            const c = m[k];
            if (!c) return;
            (c.css || []).forEach((f) => css(base + f));
            (c.imports || []).forEach(walk);
          };
          walk(w.dataset.entryKey);
        })
        .catch(() => {})
        .finally(() => {
          const s = document.createElement('script');
          s.type = 'module';
          s.src = src;
          document.head.append(s);
        });
    // Judge.me's core (base, common, the write-review form): its loader only fetches these when a widget is
    // on the page at load, and the widget gives up on its form if they don't arrive within 10 s. So: core
    // first, then the widget, exactly as the loader would have done at load.
    if (j.$) return widget();
    if (j.loadCSS && j.widgetPath) {
      j.loadCSS(j.widgetPath('base.css'));
      j.loadCSS(j.widgetPath('main.css'));
    }
    j.loadScript('widget/base.js', () =>
      j.loadScript('widget/common.js', () => {
        setTimeout(() => j.triggerVanillaEvent && j.triggerVanillaEvent('finishLoadingCore'), 0);
        j.loadScript(`${j.CDN_HOST}widget/write_review_modal.js`);
        widget();
      })
    );
  };
  const openJm = (t) => {
    const jm = t.closest('.sd-crv').querySelector('[data-crv-jm]');
    if (!jm) return allReviews();
    const want = t.matches('[data-crv-write]') ? 'primary' : 'secondary';
    const find = () => jm.querySelector(`.jm-action-buttons__button.jm-button--${want}`);
    const b = find();
    if (b) return b.click();
    addJm(jm);
    t.setAttribute('aria-busy', 'true');
    const start = Date.now();
    const tick = () => {
      const x = find();
      if (x) {
        t.removeAttribute('aria-busy');
        x.click();
      } else if (Date.now() - start > 8000) {
        t.removeAttribute('aria-busy');
        allReviews();
      } else setTimeout(tick, 120);
    };
    tick();
  };

  document.addEventListener('sunday:buy', (e) => {
    const d = e.detail || {};
    if (!d.w) return;
    document.querySelectorAll('[data-csp-weight]').forEach((dd) => {
      let map = {};
      try {
        map = JSON.parse(dd.dataset.cspWeight) || {};
      } catch (err) {}
      const kg = map[String(d.w)];
      if (kg == null) return;
      dd.textContent = fill(dd.dataset.line, { value: kg, size: d.wname || '' });
    });
  });
  if (window.sundayBuyLast) document.dispatchEvent(new CustomEvent('sunday:buy', { detail: window.sundayBuyLast }));
}
